import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/gci/sellers/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/sellers/delete`,
        endpointGetAllRealState: `${endpointBackend}gci/real-state/getall`,
        endpoint: `${endpointBackend}gci/sellers/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.gci_company_id ? {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            } : {},
            {
                name: 'gci_real_state_id',
                type: 'select',
                label: 'Imobiliária',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllRealState,
                    label: 'name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'technical_manager',
                type: 'select',
                label: 'Responsável Técnico',
                options: [
                    { label: 'Sim', value: '1' },
                    { label: 'Não', value: '0' }
                ],
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Corretores',
        labelTitleButtonAdd: 'Incluir novo corretor',
        fieldsShowOnDelete: ['name'],
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'real_state',
                label: 'Imobiliária',
            },
            {
                name: 'name',
                label: 'Nome',
            },
            {
                name: 'creci',
                label: 'CRECI',
            },
            {
                name: 'technical_manager',
                label: 'Responsável Técnico',
                width: '15%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
